import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Child from './Child';
import BaseLayout from '../../commons/BaseLayout';

const VERSION_STORAGE_KEY = '@kitoApp/version';
export default function FirstAid() {
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');
  const { id } = useParams();
  return (
    <BaseLayout sidebar header headerLogo onVersionChange={setActiveVersion} fitHeight>
      <Child firstAidId={id} />
    </BaseLayout>
  );
}
